// extracted by mini-css-extract-plugin
export var arrow = "CopyLink-module--arrow--1f6f2";
export var arrowNo = "CopyLink-module--arrow_no--d55d9";
export var arrowYes = "CopyLink-module--arrow_yes--8d6de";
export var contentContainer = "CopyLink-module--contentContainer--024c6";
export var copyButton = "CopyLink-module--copyButton--968c1";
export var copyIcon = "CopyLink-module--copyIcon--04481";
export var copyLinkButtonContainer = "CopyLink-module--copyLinkButtonContainer--3b255";
export var copyLinkContainer = "CopyLink-module--copyLinkContainer--86b72";
export var copyLinkModal = "CopyLink-module--copyLinkModal--762b0";
export var copyLinkModalTitle = "CopyLink-module--copyLinkModalTitle--beb15";
export var copyLinkText = "CopyLink-module--copyLinkText--d851e";
export var copySuccess = "CopyLink-module--copySuccess--a9de0";
export var flex = "CopyLink-module--flex--71d3d";
export var flex1 = "CopyLink-module--flex_1--bc838";
export var flexCenter = "CopyLink-module--flex_center--b0e69";
export var flexCenterCol = "CopyLink-module--flex_center_col--b5dc2";
export var flexCol = "CopyLink-module--flex_col--72a02";
export var flexFixCenterCol = "CopyLink-module--flex_fix_center_col--983aa";
export var flexFixedCenterCol = "CopyLink-module--flex_fixed_center_col--c0f99";
export var linkIcon = "CopyLink-module--linkIcon--73dde";
export var linkText = "CopyLink-module--linkText--d6959";
export var rotating = "CopyLink-module--rotating--86e07";